import { Component, Vue, Prop } from 'vue-property-decorator';
import { EvaluationProcessBarStep } from '@/models';
import { EVALUATION_STEPS, PROJECT_ASSESSMENT_STATUSES, PROJECT_TYPES } from '@/constants';

@Component
export default class EvaluationProcessBar extends Vue {
  @Prop() activeStep: string;

  get isProjectHasOneMember(): boolean {
    return this.$store.getters['project/userEngagements'].length === 1;
  }

  get isIndividualTrackingProject(): boolean {
    return this.$store.getters['project/projectType'] === PROJECT_TYPES.INDIVIDUAL_TRACKING;
  }

  get activeStepIndex(): number {
    let maxStep = this.isProjectHasOneMember ? 4 : 5;

    if (this.isIndividualTrackingProject) {
      maxStep = 3;
    }
    if (this.activeStep === EVALUATION_STEPS[PROJECT_ASSESSMENT_STATUSES.RESULT_RELEASE].key) {
      return maxStep;
    }
    return this.configs.findIndex(config => config.key === this.activeStep);
  }

  get configs(): EvaluationProcessBarStep[] {
    let evaluationStep;

    if (this.isIndividualTrackingProject) {
      evaluationStep = Object.values(EVALUATION_STEPS).filter(es => es.key !== PROJECT_ASSESSMENT_STATUSES.PEER_EVALUATION && es.key !== PROJECT_ASSESSMENT_STATUSES.PROJECT_EVALUATION);
    } else if (this.isProjectHasOneMember) {
      evaluationStep = Object.values(EVALUATION_STEPS).filter(es => es.key !== PROJECT_ASSESSMENT_STATUSES.PEER_EVALUATION);
    } else
      evaluationStep = Object.values(EVALUATION_STEPS);

    return evaluationStep.map(step => ({
      key: step.key,
      title: step.name,
      subTitle: step.role
    }));
  }
}
